import { Masks } from "@hooks/functions/Masks/Masks";
import React, { useState } from "react";

import { FiEye, FiEyeOff } from "react-icons/fi";

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  animated?: boolean;
  mask?: "phone" | "cpf" | "cnpj" | "cep" | "data";
  register?: any;
  icon?: any;
  errorMessage?: string;
  onChange?: (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  onClick?: (
    event: React.MouseEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  onFocus?: (
    event: React.FocusEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  onBlur?: (
    event: React.FocusEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
}

const masks = new Masks();

export function InputGroup({
  label,
  animated,
  register,
  mask,
  type,
  placeholder,
  icon,
  errorMessage,
  onChange,
  onClick,
  onFocus,
  onBlur,
  ...rest
}: IProps) {
  const [showPassword, setShowPassword] = useState(false);

  const maskObj = {
    phone: masks.phone,
    cpf: masks.cpf,
    cnpj: masks.cnpj,
    cep: masks.postalCode,
    data: masks.date,
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (mask && maskObj[mask]) {
      e.target.value = maskObj[mask](e.target.value);
    }

    if (register?.onChange) {
      register.onChange(e);
    }

    if (onChange) {
      onChange(e);
    }
  };

  return (
    <>
      {animated && (
        <div className="mb-3">
          <div className="input-group">
            <div className="form-floating flex-grow-1">
              <input
                className={`form-control ${errorMessage ? "is-invalid" : ""}`}
                placeholder={placeholder}
                type={
                  type === "password" && showPassword ? "text" : type ?? "text"
                }
                {...register}
                {...rest}
                onChange={handleChange}
                onClick={onClick}
                onFocus={onFocus}
                onBlur={onBlur}
              />
              <label>{label}</label>
            </div>

            {type === "password" && (
              <button
                type="button"
                className="border-0"
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
              >
                {showPassword ? <FiEye /> : <FiEyeOff />}
              </button>
            )}

            {type !== "password" && (
              <span className="input-group-text">{icon}</span>
            )}
          </div>

          {/* Mensagem de erro FORA do input-group */}
          {errorMessage && (
            <div className="invalid-feedback d-block">{errorMessage}</div>
          )}
        </div>
      )}

      {!animated && (
        <div>
          {label && <label className="form-label text-white">{label}</label>}
          <div className={`input-group mb-3 input-${type}`}>
            <input
              className={`form-control ${errorMessage ? "is-invalid" : ""}`}
              placeholder={placeholder}
              type={
                type === "password" && showPassword ? "text" : type ?? "text"
              }
              {...register}
              {...rest}
              onChange={handleChange}
              onClick={onClick}
              onFocus={onFocus}
              onBlur={onBlur}
            />
            {type === "password" && (
              <button
                type="button"
                className="border-0 btn btn-white"
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
              >
                {showPassword ? <FiEye /> : <FiEyeOff />}
              </button>
            )}

            {errorMessage && (
              <div className="invalid-feedback">{errorMessage}</div>
            )}

            {type !== "password" && (
              <span className="input-group-text">{icon}</span>
            )}
          </div>
        </div>
      )}
    </>
  );
}
